import { createSlice } from "@reduxjs/toolkit";
import { sendDoctorAssistantMessage } from "../thunks/doctorAssistantThunks";

const initialState = {
    status: "idle",
    lastReply: null,
    error: null,
};

const doctorAssistantSlice = createSlice({
    name: "doctorAssistant",
    initialState,
    reducers: {
        resetDoctorAssistantState: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(sendDoctorAssistantMessage.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(sendDoctorAssistantMessage.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.lastReply = action.payload;
            })
            .addCase(sendDoctorAssistantMessage.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload || { error: "unknown_error" };
            });
    },
});

export const { resetDoctorAssistantState } = doctorAssistantSlice.actions;
export default doctorAssistantSlice.reducer;
